import { useEffect, useState } from "react";
import { mostraAlertaError, mostraAlertaOk } from "../../../componentes/alerts/sweetAlert";
import { AxiosPrivado } from "../../../componentes/axios/Axios";
import Card from "../../../componentes/contenedores/Card";
import ModalBootstrap from "../../../componentes/modal/ModalBootstrap";
import Page from "../../../componentes/plantilla/Page";
import { ImagenProducto, PromocionesGuardar,PromocionesListar } from "../../../configuracion/apiUrls";
import { useContextEmpleado } from "../../../contexto/empleado/EmpleadoContext";

const HomePromocion = () => {
    const [productoSearchTerm, setProductoSearchTerm] = useState("");
    const [paginaActual, setPaginaActual] = useState(1);
    const [productos, setProductos] = useState([]);
    const [productosSeleccionados, setProductosSeleccionados] = useState([]);
    const { listaProductos, setListaPromociones, ActualizarLista } = useContextEmpleado();
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [errorNombre, setErrorNombre] = useState(false);
    const [errorDescripcion, setErrorDescripcion] = useState(false);
    const [errorFechaInicio, setErrorFechaInicio] = useState(false);
    const [errorFechaFin, setErrorFechaFin] = useState(false);
    const [errorHoraInicio, setErrorHoraInicio] = useState(false);
    const [errorHoraFin, setErrorHoraFin] = useState(false);
    const [errorLimiteTotal, setErrorLimiteTotal] = useState(false);
    const [errorLimiteCliente, setErrorLimiteCliente] = useState(false);

    const transformarProductos = (listaProductos) =>
        Array.isArray(listaProductos) && listaProductos.length > 0
            ? listaProductos
                .filter((p) => p.promocion === "Inactivo")
                .map((p) => ({
                    id: p.id,
                    nombre: p.nombre,
                    descripcion: p.descripcion,
                    precio: p.precio,
                    existencia: p.existencia,
                    tipo: p.tipo,
                    codigo: p.codigo,
                    promocion: p.promocion,
                    imagen: p.productoImagens?.[0]?.imagen
                        ? ImagenProducto + p.productoImagens[0].imagen
                        : "/productos.jpg",
                }))
            : [];

    useEffect(() => {
        const productosTransformados = transformarProductos(listaProductos);
        setProductos(productosTransformados);
    }, [listaProductos]);

    const agregarProductoSeleccionado = (producto) => {
        const porcentaje = parseFloat(FormulacioPromocion.descuento.replace("%", "")) || 0;
        const factor = 1 - porcentaje / 100;
        const precioConDescuento = producto.precio * factor;
        setProductosSeleccionados((prev) => {
            const index = prev.findIndex(p => p.productoId === producto.id);
            if (index !== -1) {
                const actualizados = [...prev];
                actualizados[index] = {
                    ...actualizados[index],
                    cantidad: actualizados[index].cantidad + 1,
                };
                return actualizados;
            } else {
                const nuevoItem = {
                    productoId: producto.id,
                    nombre: producto.nombre,
                    cantidad: 1,
                    precio: parseFloat(precioConDescuento.toFixed(2)),
                    precioOriginal: producto.precio,
                    precioManual: false,
                };
                return [...prev, nuevoItem];
            }
        });
        setModalIsOpen(false);
    };
    

    const aplicarDescuentoProductos = (descuentoStr) => {
        const porcentaje = parseFloat(descuentoStr.replace("%", "")) || 0;
        const factor = 1 - porcentaje / 100;
        const productosActualizados = productosSeleccionados.map((producto) => {
            if (producto.precioManual) return producto;
            const nuevoPrecio = producto.precioOriginal * factor;
            return {
                ...producto,
                precio: parseFloat(nuevoPrecio.toFixed(2)),
            };
        });
        setProductosSeleccionados(productosActualizados);
    };


    const eliminarProducto = (index) => {
        const copia = [...productosSeleccionados];
        copia.splice(index, 1);
        setProductosSeleccionados(copia);
    };

    const handleProductoChange = (index, field, value) => {
        const copia = productosSeleccionados.map((item, i) => {
            if (i === index) {
                return {
                    ...item,
                    [field]: value,
                    ...(field === "precio" ? { precioManual: true } : {})
                };
            }
            return item;
        });
        setProductosSeleccionados(copia);
    };

    const datos = {
        titulo: {
            titulo: "Nueva promoción",
            url: "/app/admin/promociones/nuevo",
            tituloUrl: "Menú Promociones",
            nombreUrl: "Inicio ",
        },
    };

    const [FormulacioPromocion, setFormulacioPromocion] = useState({
        nombre: "",
        descripcion: "",
        tipo: "Unico",
        fechaInicio: "",
        fechaFin: "",
        hora_inicio: "",
        hora_fin: "",
        diasSemana: "",
        estado: "Activo",
        descuento: "5%",
        descuentoTotal: 0,
        limite_total: 0,
        limite_cliente: 0,
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormulacioPromocion((prev) => ({ ...prev, [name]: value }));
        if (name === "descuento") {
            aplicarDescuentoProductos(value);
        }
    };

    const handleDiasSemanaChange = (dia, checked) => {
        let seleccionados = FormulacioPromocion.diasSemana.split(",").filter(Boolean);
        if (checked) {
            if (dia === "Todos") {
                seleccionados = ["Todos"];
            } else {
                seleccionados = seleccionados.filter((d) => d !== "Todos");
                if (!seleccionados.includes(dia)) {
                    seleccionados.push(dia);
                }
            }
        } else {
            seleccionados = seleccionados.filter((d) => d !== dia);
        }

        setFormulacioPromocion((prev) => ({
            ...prev,
            diasSemana: seleccionados.join(","),
        }));
    };

    const limpiarDatos = () => {
        setFormulacioPromocion({
            id: null,
            nombre: "",
            descripcion: "",
            tipo: "Unico",
            fechaInicio: "",
            fechaFin: "",
            hora_inicio: "",
            hora_fin: "",
            diasSemana: "",
            estado: "Activo",
            descuento: "5%",
            descuentoTotal: 0,
            limite_total: "",
            limite_cliente: "",
        });
    };

    const guardarPromocion = async () => {
        let tieneErrores = false;

        if (!FormulacioPromocion.nombre.trim()) {
            setErrorNombre(true);
            tieneErrores = true;
        }
        if (!FormulacioPromocion.descripcion.trim()) {
            setErrorDescripcion(true);
            tieneErrores = true;
        }
        if (!FormulacioPromocion.fechaInicio) {
            setErrorFechaInicio(true);
            tieneErrores = true;
        }
        if (!FormulacioPromocion.fechaFin) {
            setErrorFechaFin(true);
            tieneErrores = true;
        }
        if (!FormulacioPromocion.hora_inicio) {
            setErrorHoraInicio(true);
            tieneErrores = true;
        }
        if (!FormulacioPromocion.hora_fin) {
            setErrorHoraFin(true);
            tieneErrores = true;
        }
        if (FormulacioPromocion.limite_total < 0 || isNaN(FormulacioPromocion.limite_total)) {
            setErrorLimiteTotal(true);
            tieneErrores = true;
        }
        if (FormulacioPromocion.limite_cliente < 0 || isNaN(FormulacioPromocion.limite_cliente)) {
            setErrorLimiteCliente(true);
            tieneErrores = true;
        }

        if (tieneErrores) {
            mostraAlertaError("Por favor, corrige los campos marcados.");
            return;
        }

        try {
            await AxiosPrivado.post(PromocionesGuardar, {
                ...FormulacioPromocion,
                promocionDetalle: productosSeleccionados,
            });
            mostraAlertaOk("Promoción guardada exitosamente");
            ActualizarLista(PromocionesListar, setListaPromociones);
            limpiarDatos();
            setProductosSeleccionados([]);
        } catch (error) {
            console.error("Error al actualizar la promoción:", error);
            if (error.response) {
                const { status, data } = error.response;
                if (status === 400 && Array.isArray(data)) {
                    const mensajes = data.map(e => `• ${e.msg}`).join("<br/>");
                    mostraAlertaError("Errores de validación", mensajes);
                    return;
                }
                if (data?.error) {
                    mostraAlertaError("Error", data.error);
                    return;
                }
            }
            mostraAlertaError("Error", "No se pudo guardar la promoción.");
        }
        
    };    

    const dias = ["Todos", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];

    const filteredProductos = productos.filter((producto) =>
        (producto.nombre + producto.codigo).toLowerCase().includes(productoSearchTerm.toLowerCase())
    );

    const productosPorPagina = 5;
    const indexUltimo = paginaActual * productosPorPagina;
    const indexPrimero = indexUltimo - productosPorPagina;
    const productosPagina = filteredProductos.slice(indexPrimero, indexUltimo);
    const totalPaginas = Math.ceil(filteredProductos.length / productosPorPagina);

    const manejadorPromocion = (event) => {
        const { name, value } = event.target;
        setFormulacioPromocion((prev) => ({
            ...prev,
            [name]: value,
        }));
        if (name === "nombre") setErrorNombre(false);
        if (name === "descripcion") setErrorDescripcion(false);
        if (name === "fechaInicio") setErrorFechaInicio(false);
        if (name === "fechaFin") setErrorFechaFin(false);
        if (name === "hora_inicio") setErrorHoraInicio(false);
        if (name === "hora_fin") setErrorHoraFin(false);
        if (name === "limite_total") setErrorLimiteTotal(false);
        if (name === "limite_cliente") setErrorLimiteCliente(false);
        if (name === "descuento") {
            aplicarDescuentoProductos(value);
        }
    };

    return (
        <Page datos={datos}>
            <Card pie={
                <div className="col-12 text-end mt-4">
                    <button className="btn btn-success" onClick={guardarPromocion}>
                        <i className="fas fa-save me-2 mx-2" />
                        Guardar Promoción
                    </button>
                </div>
            }>
                <div className="row gy-4 gx-3">
                    <div className="col-md-6 mb-3">
                        <label className="form-label">Nombre</label>
                        <input
                            className={`form-control ${errorNombre ? "is-invalid" : ""}`}
                            name="nombre"
                            value={FormulacioPromocion.nombre}
                            onChange={manejadorPromocion}
                            onBlur={() => {
                                if (!FormulacioPromocion.nombre.trim()) {
                                    setErrorNombre(true);
                                }
                            }}
                        />
                        {errorNombre && <div className="invalid-feedback">El nombre es requerido.</div>}
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label">Descripción</label>
                        <input
                            className={`form-control ${errorDescripcion ? "is-invalid" : ""}`}
                            name="descripcion"
                            value={FormulacioPromocion.descripcion}
                            onChange={manejadorPromocion}
                            onBlur={() => {
                                if (!FormulacioPromocion.descripcion.trim()) {
                                    setErrorDescripcion(true);
                                }
                            }}
                        />
                        {errorDescripcion && <div className="invalid-feedback">La descripción es requerida.</div>}
                    </div>
                    <div className="col-md-4 mb-3">
                        <label className="form-label">Tipo</label>
                        <select
                            className="form-select mx-1"
                            name="tipo"
                            value={FormulacioPromocion.tipo}
                            onChange={handleChange}>
                            {["Total", "Unico", "Combo", "Evento"].map((op) => (
                                <option key={op} value={op}>{op}</option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-4 mb-3">
                        <label className="form-label">Descuento</label>
                        <select
                            className="form-select mx-1"
                            name="descuento"
                            value={FormulacioPromocion.descuento}
                            onChange={handleChange}>
                            {["5%", "10%", "15%", "20%", "25%", "30%", "35%", "40%", "45%", "50%"].map((op) => (
                                <option key={op} value={op}>{op}</option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-4 mb-3">
                        <label className="form-label">Estado</label>
                        <select
                            className="form-select mx-1"
                            name="estado"
                            value={FormulacioPromocion.estado}
                            onChange={handleChange}>
                            {["Activo", "Inactivo", "Agotado"].map((op) => (
                                <option key={op} value={op}>{op}</option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label">Fecha Inicio</label>
                        <input
                            className={`form-control ${errorFechaInicio ? "is-invalid" : ""}`}
                            type="date"
                            name="fechaInicio"
                            value={FormulacioPromocion.fechaInicio}
                            onChange={manejadorPromocion}
                            onBlur={() => {
                                if (!FormulacioPromocion.fechaInicio) {
                                    setErrorFechaInicio(true);
                                }
                            }}
                        />
                        {errorFechaInicio && <div className="invalid-feedback">La fecha de inicio es requerida.</div>}
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label">Fecha Fin</label>
                        <input
                            className={`form-control ${errorFechaFin ? "is-invalid" : ""}`}
                            type="date"
                            name="fechaFin"
                            value={FormulacioPromocion.fechaFin}
                            onChange={manejadorPromocion}
                            onBlur={() => {
                                if (!FormulacioPromocion.fechaFin) {
                                    setErrorFechaFin(true);
                                }
                            }}
                        />
                        {errorFechaFin && <div className="invalid-feedback">La fecha de fin es requerida.</div>}
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label">Hora Inicio</label>
                        <input
                            className={`form-control ${errorHoraInicio ? "is-invalid" : ""}`}
                            type="time"
                            name="hora_inicio"
                            value={FormulacioPromocion.hora_inicio}
                            onChange={manejadorPromocion}
                            onBlur={() => {
                                if (!FormulacioPromocion.hora_inicio) {
                                    setErrorHoraInicio(true);
                                }
                            }}
                        />
                        {errorHoraInicio && <div className="invalid-feedback">La hora de inicio es requerida.</div>}
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label">Hora Fin</label>
                        <input
                            className={`form-control ${errorHoraFin ? "is-invalid" : ""}`}
                            type="time"
                            name="hora_fin"
                            value={FormulacioPromocion.hora_fin}
                            onChange={manejadorPromocion}
                            onBlur={() => {
                                if (!FormulacioPromocion.hora_fin) {
                                    setErrorHoraFin(true);
                                }
                            }}
                        />
                        {errorHoraFin && <div className="invalid-feedback">La hora de fin es requerida.</div>}
                    </div>
                    <div className="col-12 mb-3">
                        <label className="form-label">Días de la Semana</label>
                        <div className="d-flex flex-wrap">
                            {dias.map((dia) => (
                                <div
                                    key={dia}
                                    className="form-check me-4 mb-2"
                                    style={{ minWidth: "120px" }}
                                >
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id={dia}
                                        checked={FormulacioPromocion.diasSemana.split(",").includes(dia)}
                                        onChange={(e) => handleDiasSemanaChange(dia, e.target.checked)}
                                    />
                                    <label className="form-check-label ms-2" htmlFor={dia}>
                                        {dia}
                                    </label>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="col-md-4 mb-3">
                        <label className="form-label">Descuento Total (L)</label>
                        <input
                            className="form-control"
                            type="number"
                            step="0.01"
                            name="descuentoTotal"
                            value={FormulacioPromocion.descuentoTotal}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="col-md-4 mb-3">
                        <label className="form-label">Límite Total</label>
                        <input
                            className={`form-control ${errorLimiteTotal ? "is-invalid" : ""}`}
                            type="number"
                            name="limite_total"
                            value={FormulacioPromocion.limite_total}
                            onChange={(e) => {
                                const value = parseInt(e.target.value, 10);
                                if (value >= 0 || isNaN(value)) {
                                    manejadorPromocion(e);
                                }
                            }}
                            onBlur={() => {
                                if (isNaN(FormulacioPromocion.limite_total) || FormulacioPromocion.limite_total < 0) {
                                    setErrorLimiteTotal(true);
                                }
                            }}
                        />
                        {errorLimiteTotal && <div className="invalid-feedback">Debe ser un número válido mayor o igual a 0.</div>}
                    </div>
                    <div className="col-md-4 mb-3">
                        <label className="form-label">Límite por Cliente</label>
                        <input
                            className={`form-control ${errorLimiteCliente ? "is-invalid" : ""}`}
                            type="number"
                            name="limite_cliente"
                            value={FormulacioPromocion.limite_cliente}
                            onChange={(e) => {
                                const value = parseInt(e.target.value, 10);
                                if (value >= 0 || isNaN(value)) {
                                    manejadorPromocion(e);
                                }
                            }}
                            onBlur={() => {
                                if (isNaN(FormulacioPromocion.limite_cliente) || FormulacioPromocion.limite_cliente < 0) {
                                    setErrorLimiteCliente(true);
                                }
                            }}
                        />
                        {errorLimiteCliente && <div className="invalid-feedback">Debe ser un número válido mayor o igual a 0.</div>}
                    </div>
                </div>

                {FormulacioPromocion.tipo !== "Total" ? (
                    <div className="mt-3 p-3 border rounded">
                        <h5 className="mb-3">
                            <i className="fas fa-list me-2 mx-2"></i>Detalle del promoción
                        </h5>

                        <ModalBootstrap
                            titulo="Seleccionar Productos para Combo"
                            nombreBoton="Agregar Producto"
                            estiloBoton="btn btn-primary me-2 mb-2"
                            iconBoton="fas fa-cart-plus"
                            modalIsOpen={modalIsOpen}
                            setModalIsOpen={setModalIsOpen}
                        >
                            <div className="mb-3 d-flex">
                                <div className="col-md-6 col-sm-8">
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Buscar producto por nombre o código..."
                                        value={productoSearchTerm}
                                        onChange={(e) => setProductoSearchTerm(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="table-responsive">
                                <table className="table table-bordered table-striped table-hover shadow-sm">
                                    <thead className="bg-dark text-white">
                                        <tr>
                                            <th>Imagen</th>
                                            <th>Nombre</th>
                                            <th>Código</th>
                                            <th>Precio</th>
                                            <th>Agregar</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {productosPagina.length > 0 ? (
                                            productosPagina.map((producto) => (
                                                <tr key={producto.id}>
                                                    <td>
                                                        <img
                                                            src={producto.imagen}
                                                            alt={producto.nombre}
                                                            className="img-thumbnail"
                                                            style={{ width: "50px", height: "50px" }}
                                                        />
                                                    </td>
                                                    <td>{producto.nombre}</td>
                                                    <td>{producto.codigo}</td>
                                                    <td>L {producto.precio}</td>
                                                    <td className="text-center align-middle">
                                                        <button
                                                            className="btn btn-success btn-sm"
                                                            onClick={() => agregarProductoSeleccionado(producto)}
                                                        >
                                                            <i className="fa-solid fa-cart-plus" />
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="5" className="text-center text-muted">
                                                    No se encontraron productos
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                <nav className="mt-2">
                                    <ul className="pagination pagination-sm justify-content-center shadow-sm bg-light p-3 rounded">
                                        <li className={`page-item ${paginaActual === 1 ? "disabled" : ""}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => setPaginaActual(paginaActual - 1)}
                                                aria-label="Anterior"
                                            >
                                                <i className="fas fa-chevron-left me-1"></i> Anterior
                                            </button>
                                        </li>
                                        {[...Array(totalPaginas)].map((_, i) => (
                                            <li
                                                key={i}
                                                className={`page-item ${paginaActual === i + 1 ? "active" : ""}`}
                                            >
                                                <button className="page-link fw-bold" onClick={() => setPaginaActual(i + 1)}>
                                                    {i + 1}
                                                </button>
                                            </li>
                                        ))}
                                        <li className={`page-item ${paginaActual === totalPaginas ? "disabled" : ""}`}>
                                            <button
                                                className="page-link"
                                                onClick={() => setPaginaActual(paginaActual + 1)}
                                                aria-label="Siguiente"
                                            >
                                                Siguiente <i className="fas fa-chevron-right ms-1"></i>
                                            </button>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </ModalBootstrap>

                        {productosSeleccionados.length > 0 && (
                            <div className="table-responsive mb-3">
                                <table className="table table-bordered">
                                    <thead className="bg-light">
                                        <tr>
                                            <th>Producto</th>
                                            <th>Cantidad</th>
                                            <th>Precio Original</th>
                                            <th>Precio con Descuento</th>
                                            <th>Subtotal</th>
                                            <th>Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {productosSeleccionados.map((item) => (
                                            <tr key={item.productoId}>
                                                <td>{item.nombre}</td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        min="1"
                                                        value={item.cantidad}
                                                        onChange={(e) =>
                                                            handleProductoChange(
                                                                item.productoId,
                                                                "cantidad",
                                                                Math.max(1, parseInt(e.target.value) || 1)
                                                            )
                                                        }
                                                        style={{ width: "80px" }}
                                                    />
                                                </td>
                                                <td>
                                                    {new Intl.NumberFormat("es-HN", {
                                                        style: "currency",
                                                        currency: "HNL",
                                                    }).format(item.precioOriginal)}
                                                </td>
                                                <td>
                                                    <input
                                                        type="number"
                                                        step="0.01"
                                                        className="form-control"
                                                        min="0"
                                                        value={item.precio}
                                                        onChange={(e) =>
                                                            handleProductoChange(
                                                                item.productoId,
                                                                "precio",
                                                                Math.max(0, parseFloat(e.target.value) || 0)
                                                            )
                                                        }
                                                        style={{ width: "100px" }}
                                                    />
                                                </td>
                                                <td>
                                                    {new Intl.NumberFormat("es-HN", {
                                                        style: "currency",
                                                        currency: "HNL",
                                                    }).format(item.precio * item.cantidad)}
                                                </td>
                                                <td>
                                                    <button
                                                        type="button"
                                                        className="btn btn-danger btn-sm"
                                                        onClick={() => eliminarProducto(item.productoId)}
                                                    >
                                                        <i className="fas fa-trash"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                    <tfoot>
                                        <tr className="bg-light">
                                            <td colSpan="4" className="text-end">
                                                <strong>Total:</strong>
                                            </td>
                                            <td>
                                                <strong>
                                                    {new Intl.NumberFormat("es-HN", {
                                                        style: "currency",
                                                        currency: "HNL",
                                                    }).format(
                                                        productosSeleccionados.reduce(
                                                            (total, item) => total + item.precio * item.cantidad,
                                                            0
                                                        )
                                                    )}
                                                </strong>
                                            </td>
                                            <td></td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        )}
                    </div>
                ) : (
                    <div className="alert alert-info mt-3">
                        <i className="fas fa-info-circle me-2 mx-2"></i>
                        Las promociones de tipo <strong>Total</strong> se aplican a toda la compra, no necesitan selección de productos.
                    </div>
                )}
            </Card>
        </Page>
    );
};

export default HomePromocion;